import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex } from '@radix-ui/themes';
import { StatefulConnect } from '@rango-dev/widget-embedded';
import { useInsertionEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { UNIMPAIRED_STYLE_CLASS_NAME } from '../../constants/styles';
import { useStatefulConnect } from '../../hooks/useStatefulConnect';
import { widgetThemeScopeClassName } from '../WidgetThemeScope';
import { ensureStatefulConnectStyles, STATEFUL_CONNECT_BODY_CLASS } from './statefulConnectStyles';
const { DerivationPath, isOnDerivationPath, isOnNamespace, Namespaces, Detached, isOnDetached } = StatefulConnect;
/*
 * The namespace / derivation-path / detached views still use the widget's
 * `@rango-dev/ui` (Stitches) tokens, but render inside Radix Themes' global
 * `.radix-themes` scope — which shadows the widget's `space` scale. The body is
 * tagged with `widgetThemeScopeClassName` (see WidgetThemeScope) to re-assert
 * the widget's non-color tokens locally so its spacing survives.
 */
const bodyStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    flexGrow: 1,
    minHeight: 0,
    overflowY: 'auto',
    textAlign: 'left',
    padding: 20,
};
const StatefulConnectContainer = (props) => {
    // Inject the widget-tuning CSS once into <head> (see statefulConnectStyles).
    useInsertionEffect(() => {
        ensureStatefulConnectStyles();
    }, []);
    const { selectedWallet, catchErrorsWhileConnect, indexInStack, onClose, onDetachedConfirm, detachedConfirmText, renderHeader, forceConnectToNamespaces, } = props;
    const { t } = useTranslation();
    const { getState, handleDisconnect, handleNamespace, handleDerivationPath } = useStatefulConnect();
    const handleConfirmNamespaces = (selectedNamespaces) => {
        if (selectedWallet) {
            handleNamespace(selectedWallet, selectedNamespaces).catch(catchErrorsWhileConnect);
        }
    };
    const handleConfirmDerivationPath = (derivationPath) => {
        if (!derivationPath) {
            throw new Error("Derivation path is empty. Please make sure you've filled the field correctly.");
        }
        handleDerivationPath(selectedWallet, derivationPath, {
            forceConnectToNamespaces,
        }).catch(catchErrorsWhileConnect);
    };
    const handleNavigateToDerivationPath = (selectedNamespace) => {
        if (!selectedWallet) {
            return;
        }
        void handleNamespace(selectedWallet, [selectedNamespace]).catch(catchErrorsWhileConnect);
    };
    return (_jsxs(Flex, { direction: "column", height: "100%", children: [renderHeader({
                handleClose: onClose,
                showBackButton: indexInStack > 0,
                title: t('Connect {{walletName}}', { walletName: selectedWallet.title }),
                walletName: selectedWallet.title, // TODO: This prop is added here as a workaround for resolve the problem related to texts from this package not being translated. Should remove this prop when the problem is resolved.
            }), _jsxs("div", { className: `${STATEFUL_CONNECT_BODY_CLASS} ${widgetThemeScopeClassName} ${UNIMPAIRED_STYLE_CLASS_NAME}`, style: bodyStyle, children: [isOnNamespace(getState) && (_jsx(Namespaces, { onConfirm: handleConfirmNamespaces, value: getState().namespace })), isOnDerivationPath(getState) && (_jsx(DerivationPath, { onConfirm: handleConfirmDerivationPath, value: getState().derivationPath })), isOnDetached(getState) && (_jsx(Detached, { value: getState().namespace, selectedNamespaces: getState().selectedNamespaces, navigateToDerivationPath: handleNavigateToDerivationPath, onConfirm: onDetachedConfirm, onDisconnectWallet: () => void handleDisconnect(getState().namespace.targetWallet), confirmText: detachedConfirmText }))] })] }));
};
export default StatefulConnectContainer;
